import { render, staticRenderFns } from "./VsButton.vue?vue&type=template&id=5883f994&lang=pug&"
import script from "./VsButton.vue?vue&type=script&lang=js&"
export * from "./VsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5883f994')) {
      api.createRecord('5883f994', component.options)
    } else {
      api.reload('5883f994', component.options)
    }
    module.hot.accept("./VsButton.vue?vue&type=template&id=5883f994&lang=pug&", function () {
      api.rerender('5883f994', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/viralstyle-ui/src/VsButton.vue"
export default component.exports